<template>
  <div class='notice'>
    <div class="left"></div>
    <div class="right">
      <ul class="arcGroupList">
        <li v-for="(group,index) in noticeColumn" class="group" :class="{'long':index===noticeColumn.length-1}">
          <div>
            <h2>
              <i class="iconfont iconbiaoti"></i>
              {{group.columnName}}
              <span @click="showNoticeList(group.noticeSort)">更多 ></span>
            </h2>
            <ul class="arcList">
              <div v-if="!group.list.length" class="empty">暂无数据</div>
              <li :title="item.title" @click="openDetail(item)" v-for="item in group.list">
                <h3>{{item.title}}</h3>
                <span :class="{'on':item.time==='今天'}">{{item.time}}</span>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  //通信总线
  import Bus from 'common/js/bus.js'
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';

  export default {
    name: "notice",
    mixins: [],
    data() {
      return {
        noticeColumn: []
      }
    },
    props: [],
    computed: {},
    watch: {},
    methods: {
      async fetchNoticeColumn() {
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/f_getNoticeColumnList')
        if (resp.data.status !== 1) {
          return
        }
        resp.data.data.forEach(item => {
          item.list = []
        })
        this.noticeColumn = resp.data.data
        this.fetchNoticeList()
      },
      fetchNoticeList() {
        this.noticeColumn.forEach(async (item) => {
          let paramStr = this.$qs.stringify({
            noticeSort: item.noticeSort,
            pageNumber: 1,
            pageSize: 5,
            state: 1,
            type: -1
          })
          let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getNoticeList?' + paramStr)
          if (resp.data.status !== 1) {
            return
          }
          item.list = resp.data.data[0].list
        })
      },
      showNoticeList(sortId) {
        this.$modal.show("notice", {type: 1, sortId})
      },
      openDetail(data) {
        let url = data.url;
        let title = data.title;
        if (data.sysId === 'ehall' && data.state === 0) {
          this.$modal.show("createNotice", {data, url, title});
        } else {
          if(data.appOpenType=='window'){
            window.open(url)
          }else{
            this.$modal.show("noticeDetail", {data, url, title});
          }
        }

      },
    },
    filters: {},
    components: {},
    activated() {
    },
    mounted() {
      this.fetchNoticeColumn()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../common/stylus/placeholder.styl"
  @import "../common/stylus/config.styl"
  .notice
    padding-top 90px
    setPositionFull()

    .right
      .arcGroupList
        overflow hidden
        padding-bottom 60px

        .group
          float left
          margin 10px
          display inline-block
          width calc(50% - 20px)
          height 310px
          background-color #FFFFFF
          border-radius 10px
          position relative

          & > div
            padding 0 30px

            h2
              color themeColor
              line-height 50px
              font-weight bold

              i.iconfont
                font-size 14px
                margin-right 5px

              span
                color #666666
                font-weight normal
                font-size 14px
                float right
                cursor pointer

                &:hover
                  font-weight bold
                  color #333333

            .arcList

              li
                height 50px
                line-height 50px
                white-space nowrap
                font-size 14px
                color #707070
                border-bottom 1px solid #EEEEEE
                cursor pointer

                &:hover
                  color themeColor
                  font-weight bold

                h3
                  max-width 80%
                  overflow hidden
                  text-overflow ellipsis
                  white-space nowrap


                span
                  margin-top -50px
                  float right

                  &.on
                    color themeColor
                    font-weight bold

</style>


// WEBPACK FOOTER //
// src/pages/notice.vue